import React from 'react';
import EmployeeLeaveManagement from '../EmployeeLeaveManagement';

const AdminLeavesPage = () => {
  return <EmployeeLeaveManagement />;
};

export default AdminLeavesPage;
